import { PartnersBrands } from '@shared/models/environment-config.model';

type PartnersBrand<Key extends PartnersBrands> = {
  attribution: string;
  faviconUrl: `assets/favicons/favicon-${Key}.png`;
  showHelpCenter: boolean;
  tabTitle: string;
};

type PartnerBranding = {
  [Key in PartnersBrands]: PartnersBrand<Key>;
};

const partnersBrandsConfig: PartnerBranding = {
  onemind: {
    attribution: 'Powered by',
    faviconUrl: 'assets/favicons/favicon-onemind.png',
    showHelpCenter: false,
    tabTitle: 'Onemind',
  },
  taikun: {
    attribution: 'Created by',
    faviconUrl: 'assets/favicons/favicon-taikun.png',
    showHelpCenter: true,
    tabTitle: 'Taikun',
  },
};

export const getPartnersBrandConfig = (partnerBrand: PartnersBrands): PartnersBrand<PartnersBrands> => {
  return partnersBrandsConfig[partnerBrand];
};
